import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  form = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      Validators.email,
    ]),
  });

  constructor(public authService: AuthService) { }

  ngOnInit(): void {
  }

  public async forgotPassword() : Promise<void> {
    if (!this.form.valid) {
      window.alert('please fill up all the required fields');
      return;
    }
    const email = await this.form.get('email') as any as string;
    await this.authService.ForgotPassword(email);
  }
}
